module.exports = __webpack_public_path__ + "image/solution_list_zw.jpg";